'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _spliceInstanceProperty = require('@babel/runtime-corejs3/core-js-stable/instance/splice');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _spliceInstanceProperty__default = /*#__PURE__*/_interopDefaultLegacy(_spliceInstanceProperty);

var History = /*#__PURE__*/function () {
  /**
   * Creates an instance of History.
   *
   * @memberof History
   */
  function History() {
    _classCallCheck__default["default"](this, History);
    this.clear();
  }

  /**
   * Return the current history pointer.
   *
   * @readonly
   * @type {number}
   * @memberof History
   */
  return _createClass__default["default"](History, [{
    key: "currentPointer",
    get: function get() {
      return this._currentPtr;
    }

    /**
     * Clear the history.
     *
     * @memberof History
     */
  }, {
    key: "clear",
    value: function clear() {
      this.historyRecord = [];
      this._currentPtr = -1;
    }

    /**
     * Update one new record into the history.
     *
     * @param {T} newRecord
     * @returns {T}
     * @memberof History
     */
  }, {
    key: "update",
    value: function update(newRecord) {
      var _context;
      this.historyRecord = _spliceInstanceProperty__default["default"](_context = this.historyRecord).call(_context, 0, this._currentPtr + 1);
      this.historyRecord.push(newRecord);
      this._currentPtr++;
      return newRecord;
    }

    /**
     * Remove the last record of the history.
     *
     * @returns {T}
     * @memberof History
     */
  }, {
    key: "removeLast",
    value: function removeLast() {
      var _context2;
      this.historyRecord = _spliceInstanceProperty__default["default"](_context2 = this.historyRecord).call(_context2, 0, this._currentPtr);
      this._currentPtr--;
      return this.historyRecord[this._currentPtr];
    }

    /**
     * Back to previous state in the history.
     *
     * @returns {T}
     * @memberof History
     */
  }, {
    key: "undo",
    value: function undo() {
      if (this._currentPtr < 0) {
        return undefined;
      }
      if (this._currentPtr > 0) {
        this._currentPtr--;
      }
      return this.historyRecord[this._currentPtr];
    }

    /**
     * Forward to next state in the history.
     *
     * @returns {T}
     * @memberof History
     */
  }, {
    key: "redo",
    value: function redo() {
      if (this._currentPtr < 0) {
        return undefined;
      }
      if (this._currentPtr < this.historyRecord.length - 1) {
        this._currentPtr++;
      }
      return this.historyRecord[this._currentPtr];
    }

    /**
     * Get the record in history of given index.
     * If no index is given, return the current active record.
     *
     * @param {number} [index=this._currentPtr]
     * @returns {T}
     * @memberof History
     */
  }, {
    key: "getRecord",
    value: function getRecord() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._currentPtr;
      return this.historyRecord[index];
    }

    /**
     * Get the history length.
     * Should use _currentPtr instead of historyRecord.length
     * in case user undo some of the history.
     *
     * @returns {number}
     * @memberof History
     */
  }, {
    key: "getHistoryLength",
    value: function getHistoryLength() {
      return this._currentPtr + 1;
    }

    /**
     * Get the length of the history record.
     *
     * @returns {number}
     * @memberof History
     */
  }, {
    key: "getHistoryRecordLength",
    value: function getHistoryRecordLength() {
      return this.historyRecord.length;
    }
  }]);
}();

exports.History = History;
